import { render, staticRenderFns } from "./reporte-individual.component.html?vue&type=template&id=7b15348e&scoped=true&"
import script from "./reporte-individual.component.ts?vue&type=script&lang=ts&"
export * from "./reporte-individual.component.ts?vue&type=script&lang=ts&"
import style0 from "./reporte-individual.component.scss?vue&type=style&index=0&id=7b15348e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b15348e",
  null
  
)

export default component.exports